import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getRevokeSoftDeletedProduct = (
    token: string,
    backend: string,
    id: string,
) => {
    return fetch(
        `${getApiUrl(backend)}revoke_soft_deleted_product/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default getRevokeSoftDeletedProduct;
